import { render, staticRenderFns } from "./EscanearProdcuto.vue?vue&type=template&id=b5ce4ee8&scoped=true&"
import script from "./EscanearProdcuto.vue?vue&type=script&lang=ts&"
export * from "./EscanearProdcuto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ce4ee8",
  null
  
)

export default component.exports